export default (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    Text: {
        paddingRight: 5,
        ...theme.typography.body,
        color: theme.colors.textLight.primary,
    },
    info: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
    icon: {
        display: 'flex',
        width: 14,
        height: 14,
        cursor: 'pointer',
        '& svg': {
            width: 14,
            height: 14,
        },
        '& path': {
            fill: theme.colors.grey[500],
        },
        '&:hover path': {
            fill: theme.colors.grey[600],
        },
    },
});
